import { gql } from "@apollo/client";

//Query
export const getWishListGroupQuery = gql`
query getWishListGroup ($profileId: Int!, $id: Int!){
    getWishListGroup(profileId: $profileId, id: $id){
        id
        name
        userId
        isPublic
        updatedAt
        wishListCount
    	wishLists {
          id
          listId
          listData {
            id
            title
            personCapacity
            beds
            bookingType
            coverPhoto
            reviewsCount,
            reviewsStarRating,
            transmission
            listPhotos {
              id
              name
              type
              status
            }
            listingData {
              basePrice
              currency
            }
            settingsData {
              listsettings {
                id
                typeId
                itemName
              }
            }
             wishListStatus
          }
        }
    }
}`;

export const getWishListGroup = gql`
query ($profileId: Int!){
    getAllWishListGroup(profileId: $profileId){
    	wishListGroupData {
        id
        name
        userId
        isPublic
        updatedAt
        wishListCount
        wishListIds
        wishListCover{
          id
          listData {
            id
            coverPhoto
            listPhotos {
              id
              name
              type
              status
            }
          }
        }
  		}
      count
      status
    }
}`;

export const getListingDataQuery = gql`
query getListingData($listId: Int!, $preview: Boolean) {
        UserListing(listId: $listId, preview: $preview) {
          wishListStatus
        }
}`;

export const getAllWishListGroupQuery = gql`
query ($profileId: Int!){
    getAllWishListGroup(profileId: $profileId){
    	wishListGroupData {
        id
        name
        userId
        isPublic
        updatedAt
        wishListCount
        wishListCover {
          id
          listId
          listData {
            id
            title
            personCapacity
            beds
            bookingType
            coverPhoto
            reviewsCount,
            reviewsStarRating,
            listPhotos {
              id
              name
              type
              status
            }
            listingData {
              basePrice
              currency
            }
            settingsData {
              listsettings {
                id
                itemName
              }
            }
          }
        }
  		}
      count
      status
    }
}`;

//Mutation
export const createWishListGroupMutation = gql`
mutation CreateWishListGroup($name: String!, $isPublic: String) {
  CreateWishListGroup(name: $name, isPublic: $isPublic) {
    status
    id
  }
}`;

export const createWishListMutation = gql`
mutation CreateWishList(
  $listId: Int!
  $wishListGroupsId: Int
  $eventKey: Boolean
) {
  CreateWishList(
    listId: $listId
    wishListGroupId: $wishListGroupsId
    eventKey: $eventKey
  ) {
    status
  }
}`;
